import React from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import CcxComponentProps from '../../../core/CcxComponent';

interface Props extends CcxComponentProps {}

const CcxContextualMenuIcon = ({ testId = 'CcxContextualMenuIcon' }: Props) => {
    return <EllipsisOutlined data-testid={testId} />;
};

export default CcxContextualMenuIcon;
